import { useAppDispatch, useAppSelector } from "../../App/hooks";
import AddIcon from "@mui/icons-material/Add";
import Modal from "../../Components/Modal/Modal";
import AddEdit from "./AddEdit";
import {
  addEditOptionDomainGroupFormValuesChangeHandler,
  setAddEditOptionDomainFormValues,
  setAddEditOptionDomainGroupFormValues,
  setIsOptionDomainAddEditGroupOpen,
  setIsOptionDomainAddEditOpen,
  setOptionDomainGroupEditFlag,
  setOptionDomainGroupTableFlag,
} from "../../Features/OptionDomain/optionDomainSlice";
import TabBox from "../../Components/Tabbox/TabBox";
import { useContext, useEffect, useState } from "react";
import Button from "../../Components/Button";
import ExceptionModalUI from "./ExceptionModalUI";
import OptionDomainTable from "../../Tables/OptionDomain/OptionDomain/OptionDomainTable";
import BaseInsCalculationsTableTable from "../../Tables/OptionDomain/BaseInsCalculations/BaseInsCalculationsTable";
import TextInput from "../../Components/TextInput";
import {
  addGroup,
  editGroup,
  getOptionInstruments,
  getLiveWatchlistExcel,
  getpairPositionExcel,
  getRiskFreeRate,
  setServerRiskFreeRate,
} from "../../Requests/optionDomain";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { toast } from "react-toastify";
import CheckBox from "../../Components/Checkbox";
import { Report } from "../../Interfaces/TableInterfaces";
import {
  IGetRiskFreeRateResp,
  IGroupAddEditDTO,
  IOptionDomainFormValues,
  IOptionDomainSearchParams,
} from "../../Interfaces/optionDomain";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { getStepInstruments } from "../../Requests/stepRequests";
import GroupTable from "../../Tables/OptionDomain/Group/GroupTable";
import WhiteListTable from "../../Tables/OptionDomain/WhiteList/WhiteListTable";
import FileDownloader from "../../Components/FileDownloader";
import { ReloadOutlined } from "@ant-design/icons";
import DynamicMultiSelectDropdown from "../../Components/Dropdown/DynamicMultiSelectDropdown";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import AdjustmentConfig from "./Adjustment/AdjustmentConfig";
import AdjustmentTablesWrapper from "./Adjustment/AdjustmentTablesWrapper";
import OptionCalculationTable from "../../Tables/OptionDomain/OptionCalculation/OptionCalculationTable";
import CustomAdjustmentConfig from "./Custom/CustomAdjustmentConfig";
import CustomAdjustmentTablesWrapper from "./Custom/CustomAdjustmentTablesWrapper";
import Adjustment from "./Adjustment2/Adjustment";
import { useSearchParams } from "react-router-dom";
import PairPositionWrapper from "./PairPosition/PairPositionWrapper";
import { IFilterTableCols } from "src/Tables/TableTemplate/tableTemplate";
import ServerTabBox from "src/Components/Tabbox/ServerTabBox";
import { ServerTabsContext } from "src/Layout/MasterPage";
// Local Components
import FilterSettingModal from "./PairPosition/FilterSettingModal";

enum ActiveTab {
  OptionDomain = "Home",
  OptionCalculation = "OptionCalculation",
  BaseInsCalculations = "BaseCalculations",
  PairPosition = "PairCalculations",
  Adjustment = "HedegerAdjusment",
  Adjustment2 = "NewAdjusment",
  CustomAdjustment = "Exclusive",
}

enum ModalMode {
  Closed,
  ExpectedReturn,
  OpenningSettings,
  FilterSetting,
}

interface IVisibleHeaders {
  all: boolean;
  mediator: boolean;
}

const OptionDomain = () => {
  const addEditModalFlag = useAppSelector(
    (store) => store.optionDomain.isAddEditOpen,
  );

  const addEditGroupModalFlag = useAppSelector(
    (store) => store.optionDomain.isAddEditGroupOpen,
  );

  const addEditGroupFormValues = useAppSelector(
    (store) => store.optionDomain.addEditGroupFormValues,
  );

  const groupTableFlag = useAppSelector(
    (store) => store.optionDomain.groupTableFlag,
  );
  const isGroupEdit = useAppSelector((store) => store.optionDomain.isGroupEdit);

  const dispatch = useAppDispatch();
  const [riskFreeRate, setRiskFreeRate] = useState({} as IGetRiskFreeRateResp);
  const [isRiskFreeRateOpen, setIsRiskFreeRateOpen] = useState(false);
  const [isAdjustmentConfigOpen, setIsAdjustmentConfigOpen] = useState(false);
  const [isCustomAdjustmentConfigOpen, setIsCustomAdjustmentConfigOpen] =
    useState(false);
  const [visibleHeaders, setVisibleHeaders] = useState({} as IVisibleHeaders);

  const [isExceptionsModalOpen, setIsExceptionsModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState<IOptionDomainSearchParams>(
    {} as IOptionDomainSearchParams,
  );
  const [loading, setLoading] = useState(false);

  const [refreshFlag, setRefreshFlag] = useState(false);
  const [searchParams] = useSearchParams({
    activeTab: ActiveTab.OptionDomain,
  });
  const activeTab = searchParams.get("activeTab") || "#";
  const tabs = useContext(ServerTabsContext).optionDomain;
  // local store
  const [isFilterSettingOpen, setIsFilterSettingOpen] = useState(false);

  useEffect(() => {
    getRiskFreeRate()
      .then((resp) => {
        setRiskFreeRate(resp);
        setIsRiskFreeRateOpen(false);
      })
      .catch(packetErrorHandler);
  }, []);
  useEffect(() => {
    if (groupTableFlag) dispatch(setOptionDomainGroupTableFlag(false));
  }, [groupTableFlag]);

  const getFilterCols = (tableName: string): IFilterTableCols => {
    const result: IFilterTableCols = {
      show: true,
      tableName: tableName,
      allowedPositions: [],
    };
    if (visibleHeaders.all) result.allowedPositions.push("DefaultHidden");
    if (visibleHeaders.mediator) result.allowedPositions.push("Mediator");
    return result;
  };

  const getTable = () => {
    switch (activeTab) {
      case ActiveTab.OptionDomain:
        return (
          <div className="flex flex-col justify-start items-center gap-12 w-full">
            <OptionDomainTable searchParams={searchParam} />
            <div className="relative w-full">
              <div className="w-32 mr-auto mb-5">
                <Button
                  onClick={() => {
                    dispatch(setIsOptionDomainAddEditGroupOpen(true));
                  }}
                  text="اضافه کردن گروه"
                  variant="contained"
                />
              </div>

              <GroupTable />
              <WhiteListTable />
            </div>
          </div>
        );

      case ActiveTab.BaseInsCalculations:
        return (
          <BaseInsCalculationsTableTable
            filterCols={getFilterCols("baseInsCalculationsTable")}
            searchParams={searchParam}
            refreshFlag={refreshFlag}
          />
        );

      case ActiveTab.OptionCalculation:
        return (
          <OptionCalculationTable
            filterCols={getFilterCols("optionCalculationTable")}
            searchParams={searchParam}
            refreshFlag={refreshFlag}
          />
        );

      case ActiveTab.Adjustment:
        return <AdjustmentTablesWrapper />;

      case ActiveTab.Adjustment2:
        return <Adjustment />;

      case ActiveTab.CustomAdjustment:
        return <CustomAdjustmentTablesWrapper />;

      case ActiveTab.PairPosition:
        return (
          <PairPositionWrapper
            filterCols={getFilterCols("pairPositionTable")}
            refreshFlag={refreshFlag}
            setRefreshFlag={setRefreshFlag}
          />
        );

      default:
        <></>;
    }
  };

  useEffect(() => {
    if (refreshFlag) setRefreshFlag(false);
  }, [refreshFlag]);

  const riskFreeRateChangeHandler = (name: string, value: any) => {
    setRiskFreeRate({ ...riskFreeRate, [name]: value });
  };

  const setRiskFreeRateHandler = () => {
    setLoading(true);
    setServerRiskFreeRate(riskFreeRate)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          setIsRiskFreeRateOpen(false);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const riskFreeRateModalUI = (
    <div className="w-56 flex flex-col justify-start items-center gap-5 mx-auto mt-10">
      <TextInput
        label="نرخ بهره"
        name="riskFreeRate"
        onChange={riskFreeRateChangeHandler}
        value={riskFreeRate?.riskFreeRate?.toString() || ""}
        kind="percent"
        extraLabel
      />
      <TextInput
        label="نوسان پذیری شاخص"
        name="volatilityIndicator"
        onChange={riskFreeRateChangeHandler}
        value={riskFreeRate?.volatilityIndicator?.toString() || ""}
        extraLabel
      />
      <Button onClick={setRiskFreeRateHandler} text="ثبت" variant="contained" />
    </div>
  );

  const changeHandler = (name: string, value: any) => {
    setVisibleHeaders({ ...visibleHeaders, [name]: value } as IVisibleHeaders);
  };

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  const getProperFunction = () => {
    if (isGroupEdit) return editGroup;
    return addGroup;
  };

  const addGroupHandler = () => {
    setLoading(true);
    getProperFunction()(addEditGroupFormValues)
      .then((resp) => {
        if (resp.data) {
          dispatch(setIsOptionDomainAddEditGroupOpen(false));
          dispatch(
            setAddEditOptionDomainGroupFormValues({} as IGroupAddEditDTO),
          );
          dispatch(setOptionDomainGroupTableFlag(true));
          if (isGroupEdit) dispatch(setOptionDomainGroupEditFlag(false));

          toast.success(resp.msg);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const groupChangeHandler = (name: string, value: any) => {
    dispatch(addEditOptionDomainGroupFormValuesChangeHandler({ name, value }));
  };

  const addEditGroupModalUI = (
    <div className="flex flex-col justify-start items-start gap-5 max-w-[500px]">
      <TextInput
        label="نام گروه"
        name="name"
        onChange={groupChangeHandler}
        value={addEditGroupFormValues.name}
        extraLabel
      />
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "instruments",
          placeholder: "نماد ها",
        }}
        getData={getOptionInstruments}
        onChange={groupChangeHandler}
        withTagBox
        value={addEditGroupFormValues.instruments}
      />
      <div className="flex flex-row justify-start items-center gap-3 w-32 mr-auto mt-4">
        <Button onClick={addGroupHandler} text="تایید" variant="contained" />
      </div>
    </div>
  );

  return (
    <div className="flex flex-col justify-start items-start gap-2 relative min-h-screen pt-5 mx-auto p-8 w-full">
      {addEditGroupModalFlag ? (
        <Modal title="اضافه کردن گروه"
          onClose={() => dispatch(setIsOptionDomainAddEditGroupOpen(false))}
          UI={addEditGroupModalUI}
          modalBoxClassName="!min-h-[320px]"
        />
      ) : (
        <></>
      )}
      {loading ? <FullScreenLoading /> : <></>}

      {activeTab === ActiveTab.OptionDomain ? (
        <div
          className="bg-sky-600 rounded-full flex justify-center items-center w-11 h-11 cursor-pointer absolute top-10 left-5"
          onClick={(e) => {
            dispatch(setIsOptionDomainAddEditOpen(true));
            e.stopPropagation();
          }}
        >
          <AddIcon className="text-white" />
        </div>
      ) : (
        <></>
      )}

      {addEditModalFlag ? (
        <Modal title="افزودن دامنه آپشن"
          UI={<AddEdit />}
          onClose={() => {
            dispatch(
              setAddEditOptionDomainFormValues({} as IOptionDomainFormValues),
            );
            dispatch(setIsOptionDomainAddEditOpen(false));
          }}
          modalBoxClassName="!min-w-[120px]"
        />
      ) : (
        <></>
      )}
      {isExceptionsModalOpen ? (
        <Modal title="استثناها"
          UI={<ExceptionModalUI />}
          onClose={() => setIsExceptionsModalOpen(false)}
        />
      ) : (
        <></>
      )}
      {isAdjustmentConfigOpen ? (
        <Modal title="تنظیمات تعدیل"
          UI={
            <AdjustmentConfig
              onClose={() => setIsAdjustmentConfigOpen(false)}
            />
          }
          onClose={() => setIsAdjustmentConfigOpen(false)}
          fullScreen
        />
      ) : (
        <></>
      )}
      {isFilterSettingOpen ? (
        <Modal title="تنظیمات فیلتر"
          UI={
            <FilterSettingModal
              onClose={() => setIsFilterSettingOpen(false)}
              onApplied={() => setRefreshFlag(true)}
            />
          }
          onClose={() => setIsFilterSettingOpen(false)}
          modalBoxClassName="!w-[600px]"
        />
      ) : (
        <></>
      )}
      {isCustomAdjustmentConfigOpen ? (
        <Modal title="تنظیمات تعدیل سفارشی"
          UI={
            <CustomAdjustmentConfig
              onClose={() => setIsCustomAdjustmentConfigOpen(false)}
            />
          }
          onClose={() => setIsCustomAdjustmentConfigOpen(false)}
          modalBoxClassName="!w-[600px]"
        />
      ) : (
        <></>
      )}
      <div className="flex flex-col justify-start items-start gap-3 mr-2">
        {isRiskFreeRateOpen ? (
          <Modal title="نرخ بهره بدون ریسک"
            onClose={() => setIsRiskFreeRateOpen(false)}
            UI={riskFreeRateModalUI}
            modalBoxClassName="!min-w-[120px]"
          />
        ) : (
          <></>
        )}
        <div className="w-min">
          <ServerTabBox children={tabs?.tabs} />
        </div>

        {activeTab === ActiveTab.OptionDomain ? (
          <Button
            text="تنطیمات"
            variant="outlined"
            onClick={() => setIsRiskFreeRateOpen(true)}
          />
        ) : (
          <></>
        )}
        {/* {activeTab === ActiveTab.Adjustment ? (
          <Button
            text="تنطیمات تعدیل"
            variant="outlined"
            onClick={() => setIsAdjustmentConfigOpen(true)}
          />
        ) : (
          <></>
        )} */}
        {activeTab === ActiveTab.CustomAdjustment ? (
          <Button
            text="انتخاب آپشن"
            variant="outlined"
            onClick={() => setIsCustomAdjustmentConfigOpen(true)}
          />
        ) : (
          <></>
        )}
      </div>
      <div className="flex flex-col justify-start items-start gap-3 w-full">
        {activeTab === ActiveTab.OptionCalculation ||
        activeTab === ActiveTab.PairPosition ? (
          <div className="flex flex-row justify-start items-center gap-5">
            <div className="bg-sky-200 rounded py-1 px-2">
              <CheckBox
                checked={visibleHeaders.all}
                label="جزئیات"
                name="all"
                onChange={changeHandler}
              />
            </div>
            <div className="bg-red-200 rounded py-1 px-2">
              <CheckBox
                checked={visibleHeaders.mediator}
                label="محاسبات"
                name="mediator"
                onChange={changeHandler}
              />
            </div>
            <FileDownloader getFile={
                activeTab === ActiveTab.OptionCalculation
                  ? () => getLiveWatchlistExcel(searchParam)
                  : () => getpairPositionExcel(searchParam)
              } />
            {activeTab === ActiveTab.PairPosition ? (
              <Button
                onClick={() => setIsFilterSettingOpen(true)}
                text="تنظیمات فیلتر"
                variant="outlined"
              />
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}
        <div className="flex flex-col justify-start items-start gap-1 w-full">
          <div className="flex flex-row justify-end items-center gap-3 px-2 mr-auto">
            {activeTab === ActiveTab.BaseInsCalculations ||
            activeTab === ActiveTab.OptionCalculation ? (
              <div
                onClick={() => setRefreshFlag(true)}
                className="cursor-pointer mt-5"
              >
                <ReloadOutlined />
              </div>
            ) : (
              <></>
            )}
            {activeTab === ActiveTab.BaseInsCalculations ||
            activeTab === ActiveTab.CustomAdjustment ||
            activeTab === ActiveTab.OptionCalculation ||
            activeTab === ActiveTab.OptionDomain ? (
              <div className="w-[225px] mr-auto">
                <DynamicDropdown
                  dropdown={{
                    name: "insId",
                    placeholder: "نماد",
                    extraLabel: true,
                  }}
                  getData={getStepInstruments}
                  onChange={searchParamChangeHandler}
                  value={searchParam.insId}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="w-full max-w-full overflow-x-auto">{getTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default OptionDomain;
